<div class="card" *ngIf="isAdministrative">
  <div class="card-header">
    <h1 class="h4 text-primary">Configuración Empresas Compra/Venta</h1>
    <p class="text-muted mb-0">
      Selecciona la empresa de compra que se relaciona con cada empresa fiscal.
    </p>
  </div>
  <div class="card-body">
    <div class="table-responsive">
      <table class="table table-bordered table-hover align-middle">
        <thead class="table-light">
          <tr>
            <th colspan="1" class="text-center text-danger">Empresa que Compra</th>
            <th class="text-center text-primary">Empresa que Vende (Proveedor)</th>
            <th class="text-center text-primary">% Costo</th>
            <th class="text-center text-primary"></th>
          </tr>
          <tr>
            <th>Nombre</th>
            <th class="text-center">Empresa</th>
            <th class="text-center">%</th>
            <th class="text-center"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of relationRows">
            <td>{{ item.companyPurchase.name }}</td>

            <td>
              <select class="form-select"
                      [(ngModel)]="item.companySaleId">
                <option [ngValue]="null">-- Seleccionar --</option>
                <option *ngFor="let companyPurchase of relatedAdministrative"
                        [ngValue]="companyPurchase.id">
                  {{ companyPurchase.name }}
                </option>
              </select>
            </td>

            <td class="text-center" style="max-width: 160px;">
              <div class="input-group input-group-sm">
                <input type="number"
                      class="form-control text-end"
                      [(ngModel)]="item.percentage"
                      [min]="0"
                      [max]="100"
                      step="0.01"
                      placeholder="0.00">
                <span class="input-group-text">%</span>
              </div>
            </td>

            <td class="text-center">
              <button class="btn btn-sm btn-primary" (click)="saveRelated(item)">
                <i class="fa fa-save me-1"></i>Guardar
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- <div class="mt-3 text-end">
      <button class="btn btn-success" (click)="associateCompanies()">
        <i class="fa fa-save me-2"></i>Guardar relaciones
      </button>
    </div> -->
  </div>
</div>

<div class="card" *ngIf="!isAdministrative">
  <div class="card-header">
    <h1 class="h4 text-danger">Configuración Bodegas Administrativas y Fiscales</h1>
  </div>
  <div class="card-body">
    <div class="alert alert-warning">
      Para configurar bodegas necesitas estar en una empresa <strong>administrativa</strong>.
    </div>
  </div>
</div>
